import { Icon } from "armstrong-react";
import classNames from "classnames";
import React from "react";
import { Link } from "react-router";

import { StarRating } from "../../../../core/atoms/atoms";

export class DetailRatingFragment extends React.PureComponent<{ rating: number, name: string, fragment: string, className?: string }> {
  public render() {
    const hasRating = this.props.rating != null;
    if (!hasRating) {
      return null;
    }

    const title = `${this.props.name} rated ${this.props.fragment} ${this.props.rating}/5`;

    return (
      <div className={classNames("segment-avg", this.props.className)} title={title}>
        {hasRating && <StarRating maximumValue={5} currentValue={this.props.rating} title={null} />}
        {!hasRating && <Icon className="no-rating" icon={Icon.Icomoon.minus3} />}
        {this.props.children}
      </div>
    );
  }
}
